import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { addToast, handleAxiosError } from 'core/notifications';
import i18n from 'i18next';

import NewItemForm from '../components/newItemForm';

const SimpleFormContainer = ({
  cancelRoute = '..',
  getSchemas = () => [],
  initialModel = {},
  mutation = {},
  submitText = i18n.t('create'),
}) => {
  const [formState, setFormState] = useState({});
  const [model, setModel] = useState(initialModel);
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(cancelRoute);
  };

  const handleDataErrors = (error) => {
    error.response.data?.errors?.forEach(({ message, source }) => {
      const field = formState[source.split('data.').pop()];

      if (field) {
        Object.assign(field, { error: message, hasError: true, isDirty: true });
      }
    });

    setModel({ ...model }); // trigger form update
    addToast(i18n.t('form-errors'), 'warning');
  };

  const handleSubmit = () => {
    mutation.mutate?.(model, {
      onError: (error) =>
        (error.response?.status === 422 ? handleDataErrors : handleAxiosError)(error),
    });
  };

  const handleUpdate = (state) => {
    setFormState((prevFormState) => ({ ...prevFormState, ...state.formState }));
    setModel((prevModel) => ({ ...prevModel, ...state.update }));
  };

  return (
    <NewItemForm
      hasError={Object.values(formState).some(({ hasError }) => hasError)}
      isFullScreen
      isSubmitting={mutation.isLoading}
      model={model}
      onCancel={handleCancel}
      onLoad={handleUpdate}
      onSubmit={handleSubmit}
      onUpdate={handleUpdate}
      schemas={getSchemas(model)}
      submitText={submitText}
    />
  );
};

SimpleFormContainer.propTypes = {
  cancelRoute: PropTypes.string,
  getSchemas: PropTypes.func,
  initialModel: PropTypes.shape({}),
  mutation: PropTypes.shape({}),
  submitText: PropTypes.string,
};

export default SimpleFormContainer;
